/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { Card } from 'react-bootstrap';
import FlyAshChallanGridView from 'views/challan/flyash/FlyAshChallanGridView';

// eslint-disable-next-line react/prop-types
const FlyAshProceedPaymentPending = ({
  handleBack = () => {},
  proceedData = {},
  refresh
}) => {
  const elementRef = useRef(null);

  const paymentCallback = status => {
    if (status) {
      refresh();
      handleBack();
    }
  };

  return (
    <div ref={elementRef}>
      {/* <Button
        className="p-0 d-flex align-items-center"
        variant="link"
        onClick={customBack}
        // startIcon={}
      >
        <Icon icon={'icon-park-outline:left'} fontSize="18px" className="" />
        back to list
      </Button> */}

      <Card className="bg-transparent border-0">
        <h2 className="my-3 mt-2 ms-2 font-outfit fw-medium">
          Proceed Payment
        </h2>
        <Card.Body className="pt-2">
          <FlyAshChallanGridView
            challan={proceedData?.challan_detail}
            paymentCallback={paymentCallback}
            refresh={refresh}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default FlyAshProceedPaymentPending;
